import React from 'react';
import { CallStatusCard } from '../CallAnalytics/CallStatusSummary/components';
import type { CallStatusSummaryCard } from '../CallAnalytics/CallStatusSummary/callStatusSummary.utils';
import { formatAvgDuration, type LiveMonitorStatMetrics } from './liveMonitor.utils';

import styles from './LiveMonitorStats.module.scss';

export interface LiveMonitorStatsProps {
    metrics: LiveMonitorStatMetrics;
}

type LiveMonitorStatCard = {
    card: CallStatusSummaryCard;
    primaryValue?: string;
};

export const LiveMonitorStats: React.FC<LiveMonitorStatsProps> = ({ metrics }) => {
    const items: LiveMonitorStatCard[] = [
        {
            card: {
                id: 'active',
                label: 'Active calls',
                count: metrics.activeCalls,
                percent: 0,
                variant: 'inProgress',
                tooltip: 'Calls currently dialing, ringing, in progress, transferring, or with a human on the line.',
                subStatuses: [],
            },
        },
        {
            card: {
                id: 'queued',
                label: 'Queued',
                count: metrics.queued,
                percent: 0,
                variant: 'pending',
                tooltip: 'Calls waiting in the queue to be dialed.',
                subStatuses: [],
            },
        },
        {
            card: {
                id: 'pending',
                label: 'Pending',
                count: metrics.pending,
                percent: 0,
                variant: 'overdue',
                tooltip: 'Overdue calls that have not yet been completed.',
                subStatuses: [],
            },
        },
        {
            card: {
                id: 'avg',
                label: 'Avg duration',
                count: 0,
                percent: 0,
                variant: 'avgDuration',
                tooltip: 'Average duration of calls started today (local calendar day).',
                subStatuses: [],
            },
            primaryValue: formatAvgDuration(metrics.avgDurationSeconds),
        },
    ];

    return (
        <section className={styles.section} data-testid='live-monitor-stats' aria-label='Live call statistics'>
            <div className={styles.grid}>
                {items.map(({ card, primaryValue }) => (
                    <CallStatusCard key={card.id} card={card} primaryValue={primaryValue} showPercent={false} />
                ))}
            </div>
        </section>
    );
};
